<template>
	<div class="w1200">
			<div class="association-brief-box">
				<div class="crumbs">
                     <span>首页 ></span>
                     <span><a href="#">会长致辞</a></span>
				</div>
				<div class="article-box w1000">
					<h2>会长致辞</h2>
					<p>北京建筑设施服务企业协会以建筑物为载体，将为建筑物设施服务与人的环境空间纳入进来，形成跨界的交流共享平台，实现共同学习、共同发展、共创商机的办会发展思路。
					</p>
					<p>我们都知道，地产的投资也给业主带来了丰厚的回报，但管理不善风险巨大，会增加巨额的成本；业主、租户的满意度降低，无法实现高回报；楼内人们的安全和健康面临威胁，价值减少降低；业主以及管理者面临价值与成本等压力。</p>
					<p>经过了解国外建筑设施服务商情况，使得建筑（设施）服务商从业主角度、管理者角度、租户等角度出发，让停车行走更顺畅；工作餐更加安全卫生，有营养；大楼的人们更加安全；楼内外环境卫生更加洁净等。</p>
					<p>改善环境空间，室内空气质量，实现健康安全与建筑物的设施完好，降低成本、减少浪费，我们将致力于国外建筑设施服务30年以上的成熟经验、理念和技术引进中国，实现本土化，帮助环境科技企业、设施服务企业、餐饮企业、空气检测企业、节能环保、建筑服务企业供应商等，帮助企业扩展思路，从建筑物的生命与人体健康安全考虑，提升服务产品内容要求，通过引进科技创新技术，改变单一营业模式变系统营运模式，从而搭建建筑物整体生态系统的工作生活环境空间。</p>
				</div>
			</div>

		</div>
</template>

<script>
	import Vue from 'vue';
	export default {

		data() {
			return {}
		},
		methods: {

		},
		components: {}
	}
</script>

<style>

	@import "../assets/css/detail.css";
</style>


// WEBPACK FOOTER //
// src/components/Speech.vue